var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0415 2.62492H14.8748C15.2661 2.62492 15.5832 2.94205 15.5832 3.33325V14.6666C15.5832 15.0578 15.2661 15.3749 14.8748 15.3749H2.12484C1.73364 15.3749 1.4165 15.0578 1.4165 14.6666V3.33325C1.4165 2.94205 1.73364 2.62492 2.12484 2.62492H4.95817V1.20825H6.37484V2.62492H10.6248V1.20825H12.0415V2.62492ZM2.83317 6.87492V13.9583H14.1665V6.87492H2.83317ZM4.24984 9.70825H7.7915V12.5416H4.24984V9.70825Z",
    fill: "#7C47E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDate);
export default __webpack_public_path__ + "static/media/RewardDate.da5f7134f77a9cd5fa327e94128a1ea2.svg";
export { ForwardRef as ReactComponent };